/**
 * Do nothing action.\
 * This action can be used in various scenarios, including:
 *
 * - **Placeholder Function**: Serves as a placeholder during development when the actual implementation is not yet available.
 * - **Default Callback**: Acts as a default callback action in situations where a callback is required, but no action is needed.
 * - **Testing and Debugging**: Useful for temporarily disabling certain functionality without removing the action call.
 * - **API Compliance**: Fulfills API requirements where a action must be passed, even if no action is needed.
 */
export function doNothing() {
  // Do nothing
}

/**
 * Return undefined.
 *
 * @returns {undefined} Undefined.
 */
export function returnUndefined(): undefined {
  return undefined;
}
